import { render } from "./CreateCategoryModal.vue?vue&type=template&id=81af6c68"
import script from "./CreateCategoryModal.vue?vue&type=script&lang=js"
export * from "./CreateCategoryModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__